module.exports = __webpack_public_path__ + "static/gravity-bold-webfont-405d81071588d488330ddf4cdb1d77df.woff2";